/* eslint-disable no-param-reassign */
import { useEffect } from 'react';
import { node } from 'prop-types';

import { isExcludedBot } from './botBlock';

const segmentMiddleware = ({ payload, next }) => {
  if (payload.obj.properties.path) {
    payload.obj.properties.path = window.location.pathname;
    payload.obj.properties.url = window.location.href;
    payload.obj.properties.userAgent = window.navigator.userAgent;
  }
  next(payload);
};

const SegmentPageListener = ({ children }) => {
  let clickid;
  useEffect(() => {
    if (window !== undefined) {
      const queryString = window?.location?.search;
      const urlParams = new URLSearchParams(queryString);
      clickid = urlParams.get('clickid');
    }
  }, []);

  useEffect(() => {
    if (clickid) {
      try {
        window?.localStorage?.setItem('clickid', clickid);
      } catch {
        // Do nothing on error - localStorage not accessible on client browser
      }
    }
  }, [clickid]);

  useEffect(() => {
    if (isExcludedBot) return;
    window?.analytics?.addSourceMiddleware(segmentMiddleware);
  }, []);

  useEffect(() => {
    if (isExcludedBot) return;
    if (window?.analytics?.page) {
      window.analytics.page();
    }
  }, []);

  return children;
};

SegmentPageListener.propTypes = {
  children: node.isRequired,
};

export default SegmentPageListener;
